/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEventHandler} from 'react';
import {makeStyles} from '@material-ui/core';
import {OpenModalIcon} from '../../icons/OpenModalIcon';
import {IconButton} from './IconButton';

export interface OpenModalProps {
  handleOpenModal: MouseEventHandler<HTMLButtonElement>;
}

const useStyles = makeStyles((theme) => ({
  icon : {
    padding : '0px'
  }
}));

/**
 * The OpenModal component provides a button to open a modal. 
 * 
 * Simply pass in a function via the handleOpenModal prop to handle opening a modal.
 * 
 * ```typescript
 * 
 * import OpenModal from '@ion/dls/src/components/buttons/OpenModal';
 * 
 * const [openModal, setOpenModal] = useState(false);
 * 
 * function handleOpenModal() {
 *  setOpenModal(!openModal);
 * }
 * 
 * <OpenModal handleOpenModal={handleOpenModal} />
 * 
 * ```
 * 
 * @param handleOpenModal - function to handle the open modal
 */
const OpenModal = ({handleOpenModal}: OpenModalProps) => {
  const classes = useStyles();

  return (
    <div className={classes.icon}>
      <IconButton onClick={handleOpenModal} icon={<OpenModalIcon />} padding={'0px'} />
    </div>
  );
};

export default OpenModal;
